<template>
  <div class="main-container">
    <div class="main-container-title-box-text">
      <v-btn depressed @click="back">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <div>
        <v-btn
          depressed
          @click="openDialogPush"
          outlined
          color="var(--app-dark-blue-1)"
          class="button-accept-outlined"
        >
          <span> Отправить PUSH </span>
        </v-btn>
        <v-btn
          depressed
          style="margin-left: 40px"
          @click="deleteUser"
          outlined
          color="var(--app-red-1)"
          class="button-accept-outlined"
        >
          <span> Удалить </span>
        </v-btn>
      </div>
    </div>

    <div class="info-container">
      <div class="item-box">
        <div class="item-box-title">ИД пользователя:</div>
        <div class="item-box-value">
          {{ user.id }}
        </div>
      </div>

      <div class="item-box">
        <div class="item-box-title">Дата создания:</div>
        <div class="item-box-value" v-if="user.dateCreated">
          {{ user.dateCreated | moment("HH:mm DD.MM.YYYY") }}
        </div>
      </div>

      <div class="item-box">
        <div class="item-box-title">Дата последней активности:</div>
        <div class="item-box-value" v-if="user.lastActivity">
          {{ user.lastActivity | moment("HH:mm DD.MM.YYYY") }}
        </div>
      </div>

      <div class="item-box">
        <div class="item-box-title">ИД устройства:</div>
        <div class="item-box-value">
          {{ user.deviceId }}
        </div>
      </div>
      <div class="item-box">
        <div class="item-box-title">Бандл ИД:</div>
        <div class="item-box-value">
          {{ user.appBundle }}
        </div>
      </div>

      <div class="item-box">
        <div class="item-box-title">Модель устройства:</div>
        <div class="item-box-value">
          {{ user.deviceModel }}
        </div>
      </div>
      <div class="item-box">
        <div class="item-box-title">Название магазина:</div>
        <div class="item-box-value">
          {{ user.marketName }}
        </div>
      </div>

      <div class="item-box">
        <div class="item-box-title">Каналы:</div>
        <div class="item-box-value">
          <span v-for="(item, index) in user.channels" :key="item">
            {{ item }} <span v-if="user.channels.length != index + 1">,</span>
          </span>
        </div>
      </div>
      <div class="item-box">
        <div class="item-box-title">Регионы:</div>
        <div class="item-box-value">
          <span v-for="(item, index) in user.regions" :key="item">
            {{ item }} <span v-if="user.regions.length != index + 1">,</span>
          </span>
        </div>
      </div>
      <div class="item-box" v-if="user.region">
        <div class="item-box-title">Регион по IP:</div>
        <div class="item-box-value">
          {{ user.region }}
        </div>
      </div>
      <div class="item-box" v-if="user.city">
        <div class="item-box-title">Город по IP:</div>
        <div class="item-box-value">
          {{ user.city }}
        </div>
      </div>
      <div class="item-box">
        <div class="item-box-title">Версия приложения:</div>
        <div class="item-box-value">
          {{ user.appVersion }}
        </div>
      </div>

      <div class="item-box">
        <div class="item-box-title">
          Установлено ограничение по времени отправки пушей:
        </div>
        <div class="item-box-value">
          {{ user.isNotificationTime }}
        </div>
      </div>

      <div class="item-box">
        <div class="item-box-title">Начала времени отправки:</div>
        <div class="item-box-value">
          {{ msToTime(user.fromNotificationTime) }}
        </div>
      </div>

      <div class="item-box">
        <div class="item-box-title">Конец времени отправки:</div>
        <div class="item-box-value">
          {{ msToTime(user.toNotificationTime) }}
        </div>
      </div>

      <div class="item-box">
        <div class="item-box-title">Регион пользователя:</div>
        <div class="item-box-value">
          {{ user.locale }}
        </div>
      </div>

      <div class="item-box">
        <div class="item-box-title">Версия системы:</div>
        <div class="item-box-value">
          {{ user.systemVersion }}
        </div>
      </div>

      <div class="item-box">
        <div class="item-box-title">Временная зона:</div>
        <div class="item-box-value">
          {{ user.timeZone }}
        </div>
      </div>

      <div class="item-box">
        <div class="item-box-title">Push token:</div>
        <div class="item-box-value">
          {{ user.deviceToken }}
        </div>
      </div>
      <div class="item-box" v-if="user.ruStoreToken">
        <div class="item-box-title">RuStore token:</div>
        <div class="item-box-value">
          {{ user.ruStoreToken }}
        </div>
      </div>
    </div>

    <v-dialog width="500px" height="auto" persistent v-model="dialogPush">
      <v-card width="500px" height="auto" class="rounded-0">
        <v-form lazy-validation ref="push">
          <v-card-title class="dialog-title">
            <span class="title">Отправить PUSH</span>
            <v-icon @click="closeDialog">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <v-text-field
              label="Заголовок"
              required
              type="text"
              outlined
              :rules="rules"
              v-model="push.title"
            ></v-text-field>
            <v-text-field
              label="Сообщение"
              required
              type="text"
              outlined
              :rules="rules"
              v-model="push.message"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="sendPush" class="button-accept"> Отправить </v-btn>

            <v-btn
              v-if="user.ruStoreToken"
              @click="sendPush('rustore')"
              class="button-accept"
            >
              Отправить RuStore</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog width="700px" height="auto" persistent v-model="dialogAnswerPush">
      <v-card width="700px" height="auto" class="rounded-0">
        <v-form lazy-validation ref="push">
          <v-card-title class="dialog-title">
            <span class="title">Ответ от PUSH</span>
            <v-icon @click="dialogAnswerPush = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div
              v-if="answerPush && answerPush.data && answerPush.data.length > 0"
            >
              <div v-for="(i, index) in answerPush.data" :key="index">
                <div v-for="(value, name) in i" :key="name" class="d-flex">
                  <div
                    style="font-weight: 600; font-size: 16px; min-width: 80px"
                  >
                    {{ name }}:
                  </div>
                  <div style="overflow-wrap: anywhere" class="mr-4">
                    {{ value }}
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="answerPush && answerPush.err && answerPush.err.length > 0"
            >
              <div v-for="(i, index) in answerPush.err" :key="index">
                <div v-for="(value, name) in i" :key="name" class="d-flex">
                  <div
                    style="font-weight: 600; font-size: 16px; min-width: 80px"
                    class="mr-4"
                  >
                    {{ name }}:
                  </div>
                  <div style="overflow-wrap: anywhere">
                    {{ value }}
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>

    <div class="container-block-title">Push-уведомления</div>
    <div>
      <v-data-table
        :headers="tableHeaders"
        :items="pushItems"
        :footer-props="{
          itemsPerPageOptions: [10, 25, 50],
          'items-per-page-text': '',
        }"
        class="elevation-0"
        :items-per-page="optionTable.itemsPerPage"
        :page="optionTable.page"
        :server-items-length="optionTable.serverItemsLength"
        @pagination="tableChange"
        @click:row="openDialogPushInfo"
      >
        <template v-slot:no-data>
          <div>Нет данных</div>
        </template>

        <template v-slot:item.dateCreated="{ item }">
          <template v-if="user.dateCreated">
            {{ item.dateCreated | moment("HH:mm DD.MM.YYYY") }}
          </template>
        </template>

        <template v-slot:item.isSend="{ item }">
          <span v-if="item.isSend"> Да</span>
          <span v-else>Нет</span>
        </template>
        <!-- <template v-slot:item.action="{ item }">
                         <v-icon @click="deletePush(item.id)" color="var(--app-red-1)">mdi-delete-outline</v-icon>
                </template> -->
      </v-data-table>
    </div>
    <v-dialog width="700px" height="auto" persistent v-model="dialogPushInfo">
      <v-card width="700px" height="auto" class="rounded-0">
        <v-card-title class="dialog-title">
          <span class="title">Детальная информация</span>
          <v-icon @click="dialogPushInfo = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="dialog-description">
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">ID:</div>
            <div class="dialog-view-item-text">
              {{ choisePush.id }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Пуш отправлен:</div>
            <div class="dialog-view-item-text">
              <span v-if="choisePush.isSend">Да</span>
              <span v-else>Нет</span>
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Статус отправки:</div>
            <div class="dialog-view-item-text">
              {{ choisePush.status }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Ошибка:</div>
            <div class="dialog-view-item-text">
              <span v-if="choisePush.isError">Да</span>
              <span v-else>Нет</span>
            </div>
          </div>
          <div v-if="choisePush.isError" class="dialog-view-item">
            <div class="dialog-view-item-title">Текст ошибки:</div>
            <div class="dialog-view-item-text">
              {{ choisePush.error }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">ID push:</div>
            <div class="dialog-view-item-text">
              {{ choisePush.pushId }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">ID пользователя:</div>
            <div class="dialog-view-item-text">
              {{ choisePush.userId }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Дата успешной отправки:</div>
            <div class="dialog-view-item-text" v-if="choisePush.dateSend">
              {{ choisePush.dateSend | moment(" HH:mm DD.MM.YYYY ") }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Дата создания:</div>
            <div class="dialog-view-item-text" v-if="choisePush.dateCreated">
              {{ choisePush.dateCreated | moment(" HH:mm DD.MM.YYYY ") }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Заголовок:</div>
            <div class="dialog-view-item-text">
              {{ choisePush.title }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Описание:</div>
            <div class="dialog-view-item-text">
              {{ choisePush.description }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Тип устройства:</div>
            <div class="dialog-view-item-text">
              {{ choisePush.deviceType }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">ID устройства:</div>
            <div class="dialog-view-item-text">
              {{ choisePush.deviceId }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Тип контента для перехода:</div>
            <div class="dialog-view-item-text">
              {{ choisePush.contentType }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">ID контента для перехода:</div>
            <div class="dialog-view-item-text">
              {{ choisePush.contentId }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">
              Количество попыток отправки:
            </div>
            <div class="dialog-view-item-text">
              {{ choisePush.numberRepetitions }}
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="dialog-buttons">
          <v-spacer></v-spacer>
          <v-btn @click="deletePush(choisePush.pushId)" class="button-cancel">
            Удалить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data: () => ({
    userArr: [],
    user: {},
    dialogPush: false,
    dialogPushInfo: false,
    dialogAnswerPush: false,
    choisePush: {},
    push: {},
    rules: [(value) => !!value || "Обязательно к заполнению"],
    optionTable: {
      page: 1,
      itemsPerPage: 10,
      serverItemsLength: -1,
    },
    pushItems: [],
    tableHeaders: [
      {
        text: "ID",
        sortable: false,
        value: "id",
      },
      {
        text: "Заголовок",
        sortable: false,
        value: "title",
      },
      {
        text: "Описание",
        sortable: false,
        value: "description",
      },
      {
        text: "Тип push",
        sortable: false,
        value: "contentType",
      },
      {
        text: "ID типа",
        sortable: false,
        value: "contentId",
      },
      {
        text: "Отправленно",
        sortable: false,
        value: "isSend",
      },
      {
        text: "Дата создания",
        sortable: false,
        value: "dateCreated",
      },
    ],
    answerPush: null,
  }),
  created() {
    this.getUser();
    this.getPush();
  },
  methods: {
    closeDialog() {
      this.dialogPush = false;
      this.push = {};
      this.$refs.push.reset();
      this.$refs.push.resetValidation();
    },
    deletePush(id) {
      this.$axios
        .delete(this.$store.getters.apiAdminPanelV2 + "/push", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            pushId: id,
          },
        })
        .then(() => {
          this.dialogPushInfo = false;
          this.getPush();
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    openDialogPushInfo(row) {
      this.dialogPushInfo = true;
      this.choisePush = row;
    },
    tableChange(data) {
      this.optionTable.page = data.page;
      this.optionTable.itemsPerPage = data.itemsPerPage;
      this.getPush();
    },
    msToTime(duration) {
      var minutes = parseInt((duration / (1000 * 60)) % 60),
        // ,seconds = parseInt((duration/1000)%60)
        hours = parseInt((duration / (1000 * 60 * 60)) % 24);

      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      // seconds = (seconds < 10) ? "0" + seconds : seconds;

      return hours + ":" + minutes;
    },
    openDialogPush() {
      this.dialogPush = true;
    },
    back() {
      this.$router.push({ name: "Users" });
    },
    deleteUser() {
      this.$axios
        .delete(this.$store.getters.apiAdminPanelV2 + "/user", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            id: this.$route.params.id,
          },
        })
        .then(() => {
          this.$router.push({ name: "Users" });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    sendPush(token) {
      if (this.$refs.push.validate()) {
        let apiVersion = this.$store.getters.apiAdminPanelV5;
        let headers = {
          authorization: this.$store.getters.adminPanelHeaderAuth,
          "secret-key": this.$store.state.secretKeyCookie,
        };
        let url = "/user/push";
        switch (token) {
          case "rustore":
            apiVersion = this.$store.getters.apiAdminPanelV2;
            delete headers["secret-key"];
            url = "/users/push/rustore/send";
            break;

          default:
            break;
        }

        this.$axios
          .post(
            apiVersion + url,
            {
              id: this.user.id,
              title: this.push.title,
              message: this.push.message,
            },
            {
              headers: headers,
            }
          )
          .then((res) => {
            this.answerPush = res.data;
            this.dialogAnswerPush = res.data;
            this.closeDialog();
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
      }
    },
    getUser() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV2 + "/user", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            id: this.$route.params.id,
          },
        })
        .then((res) => {
          // this.userArr = Object.entries(res.data)
          this.user = res.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getPush() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/push/user/list",
          {
            optionTable: this.optionTable,
            userId: this.$route.params.id,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.optionTable = res.data.optionTable;
          this.pushItems = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  box-sizing: border-box;
  padding: 40px 24px 0 24px;

  .main-container-title-box-text {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .info-container {
    margin-top: 20px;

    .item-box {
      // width: 50%;
      display: flex;
      margin-bottom: 20px;

      .item-box-title {
        font-size: 16px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.6);
        width: 250px;
        min-width: 250px;
      }

      .item-box-value {
        font-size: 16px;
        font-weight: 500;

        word-break: break-all;
      }
    }
  }
}

.container-block-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
}

.dialog-view-item {
  display: flex;
  margin-bottom: 10px;

  .dialog-view-item-title {
    width: 200px;
  }

  .dialog-view-item-text {
    color: black;
    width: 450px;
    word-break: break-all;
  }
}
</style>
